import { render } from "./VaPageNotFoundLargeText.vue?vue&type=template&id=a9de152a"
import script from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundLargeText.vue?vue&type=script&lang=js"

import "./VaPageNotFoundLargeText.vue?vue&type=style&index=0&id=a9de152a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__